import React from 'react'

import { ArtistEdit } from 'modules/Artists/containers'

import { Layout } from 'components'

const ArtistsEditPage = () => (
  <Layout>
    <ArtistEdit />
  </Layout>
)

export default ArtistsEditPage
